import { hydrateRoot } from "react-dom/client";

import { HelmetProvider } from "../server/utils/module.react-helmet-async";

import type { AppProps } from "./app";
import { App } from "./app";
import { CookieConsentProvider } from "./core/provider.cookie-consent";
import {
  extractPm2PathFromHref,
  PM2NavigationProvider,
} from "./core/provider.navigation";

/**
 * hydrate the application (moved to a separate file to create a tiny bootstrap
 * bundle to run authentication and authorization as early as possible).
 */
export function hydrateApp(props: AppProps): void {
  const target = document.querySelector(".pm2-root");

  if (!target) {
    throw new Error("Unable to mount app at target");
  }

  const initialPath =
    extractPm2PathFromHref(
      window.location.href,
      props.configState.baseUrl,
    ).split("#")[0] ?? "/";

  hydrateRoot(
    target,
    <HelmetProvider>
      <PM2NavigationProvider basePath={props.configState.baseUrl}>
        <CookieConsentProvider siteId={props.configState.config.id}>
          <App {...props} initialPath={initialPath} />
        </CookieConsentProvider>
      </PM2NavigationProvider>
    </HelmetProvider>,
  );
}
